import { SVGProps } from "react";

const UserIcon = ({
  color,
  height,
  width,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width={height}
      height={width}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10.0001"
        cy="5.32747"
        r="3.33333"
        stroke={color ?? "#6F7794"}
        strokeWidth="1.5"
      />
      <path
        opacity="0.5"
        d="M16.6666 14.9121C16.6666 16.9832 16.6666 18.6621 9.99992 18.6621C3.33325 18.6621 3.33325 16.9832 3.33325 14.9121C3.33325 12.841 6.31802 11.1621 9.99992 11.1621C13.6818 11.1621 16.6666 12.841 16.6666 14.9121Z"
        stroke={color ?? "#6F7794"}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default UserIcon;
